/// <amd-module name="Artifacts/Root/helpers/RoleHelpers" />
import * as Res from "Artifacts/Root/Resources";
import { FeedRole } from "Artifacts/Root/web-apis/contracts/Feed";
import * as StringUtils from "VSS/Core/Util/String";

export function roleToLocaleString(role: FeedRole): string {
  switch (role) {
    case FeedRole.Administrator:
      return Res.Permissions_Role_Owner;
    case FeedRole.Contributor:
      return Res.Permissions_Role_Contributor;
    case FeedRole.Custom:
      return Res.Permissions_Role_Custom;
    case FeedRole.None:
      return Res.Permissions_Role_None;
    case FeedRole.Reader:
      return Res.Permissions_Role_Reader;
    case FeedRole.Collaborator:
      return Res.Permissions_Role_Collaborator;
  }
}

export function stringToRole(role: string): FeedRole | undefined {
  if (StringUtils.equals(role, Res.Permissions_Role_Owner)) {
    return FeedRole.Administrator;
  }

  if (StringUtils.equals(role, Res.Permissions_Role_Contributor)) {
    return FeedRole.Contributor;
  }

  if (StringUtils.equals(role, Res.Permissions_Role_Reader)) {
    return FeedRole.Reader;
  }

  if (StringUtils.equals(role, Res.Permissions_Role_Collaborator)) {
    return FeedRole.Collaborator;
  }
}
